/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Web_VisibilityInputs */

const cs_form_web_visibility = /** @type {(inputs: Form_Web_VisibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viditelnost na webu`)
};

const en_form_web_visibility = /** @type {(inputs: Form_Web_VisibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Web visibility`)
};

/**
* | output |
* | --- |
* | "Web visibility" |
*
* @param {Form_Web_VisibilityInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_web_visibility = /** @type {((inputs?: Form_Web_VisibilityInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Web_VisibilityInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_web_visibility(inputs)
	return cs_form_web_visibility(inputs)
});